import React, { useEffect } from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import useMarketCommunitiesForm from 'utils/hooks/useMarketCommunitites';

const FormsMarketCommunities = ({ fields }) => {
  // Fields
  const displayCommunityOfInterest = fields.displayCommunityOfInterest;
  const marketCommunities = getFieldValue(fields, 'marketCommunities') || [];
  const { updateMarketForms, updateShowMarketForms } =
    useMarketCommunitiesForm();
  useEffect(() => {
    if (displayCommunityOfInterest) {
      updateShowMarketForms(displayCommunityOfInterest);
      updateMarketForms(
        marketCommunities.sort((a, b) => {
          const nameA = a.displayName.toUpperCase();
          const nameB = b.displayName.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        }),
      );
    } else {
      updateShowMarketForms(false);
      updateMarketForms([]);
    }
  }, [displayCommunityOfInterest]);

  return '';
};

export default FormsMarketCommunities;
